import { GroupService } from './../../services/group.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {ModalDetailComponent} from '../../modal-detail/modal-detail.component';

@Component({
  selector: 'app-approver-services-detail',
  templateUrl: './approver-services-detail.component.html',
  styleUrls: ['./approver-services-detail.component.scss']
})
export class ApproverServicesDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  office: any = {};
  listCompanies: any;
  editId: any;
  numOrder: any;
  viewPage: any;
  listItems = [];
  idFactura;

  constructor(private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<ApproverServicesDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private gpoService:  GroupService) {
    this.type = this.data.type;
    this.numOrder = this.data.order;
    this.editId = this.data.id;

    if(this.type === 'add'){
      this.textButton = 'ADDOFFICE';
    }

    if(this.type === 'edit'){
      this.textButton = 'ORDER';
    }

    if(this.type === 'detailOc'){
      this.textButton = 'DETAILS';
      this.listItems = this.data.items;
      this.viewPage = this.data.view;  
      this.idFactura = this.data.id;      
    }
  }

  ngOnInit() {
  }

  attatch(){
    console.log('adjuntar comprobante');
  }

  download(type){
    if(type == 1){
      console.log('descargar xml');
    }

    if(type == 2){
      console.log('descargar pdf');
    }
  }

  viewFile(url){
    console.log(url);
    let type = 'view_jpg';
    const last = url.split('.').pop();
    if(last == 'pdf'){
      type = 'view_pdf';
    }

    console.log(type,url);
    this.dialog.open(ModalDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: {type: type, url: url, title: 'Documento'}
    });
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  downloadFile(facturaId){
    //this.gpoService.
  }
}
